import React from 'react';
import { ArrowUp, Compass } from 'lucide-react';
import { studioData } from '../data/portfolioData';

export const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#07080A] border-t border-white/10 pt-16 pb-12 px-6 md:px-12 text-neutral-400 z-10">
      <div className="max-w-7xl mx-auto space-y-12">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          {/* Brand & Statement */}
          <div className="lg:col-span-5 space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-8 px-1 rounded-sm bg-white/5 border border-white/15 flex items-center justify-center text-arch-accent font-mono text-xs font-semibold">
                DG
              </div>
              <span className="font-serif text-xl tracking-wider text-white font-medium">
                {studioData.name}
              </span>
            </div>
            <p className="text-xs font-light text-neutral-400 max-w-sm leading-relaxed">
              Contemporary architectural design studio specializing in climate-responsive private residences, commercial landmarks, and tectonic spatial interiors.
            </p>
            <div className="text-[10px] font-mono text-arch-muted">
              {studioData.coordinates}
            </div>
          </div>

          {/* Navigation Links */}
          <div className="lg:col-span-3 space-y-3">
            <div className="text-[10px] font-mono text-arch-accent uppercase tracking-widest">
              Navigation Index
            </div>
            <ul className="space-y-2 text-xs font-mono">
              <li><a href="#works" className="hover:text-white transition-colors">01 Selected Works</a></li>
              <li><a href="#methodology" className="hover:text-white transition-colors">02 Methodology</a></li>
              <li><a href="#index" className="hover:text-white transition-colors">03 Monograph Index</a></li>
              <li><a href="#studio" className="hover:text-white transition-colors">04 Studio & Awards</a></li>
              <li><a href="#inquire" className="hover:text-white transition-colors">05 Client Inquiries</a></li>
            </ul>
          </div>

          {/* Socials & Inquiries */}
          <div className="lg:col-span-4 space-y-3">
            <div className="text-[10px] font-mono text-arch-accent uppercase tracking-widest">
              Direct Channels
            </div>
            <div className="space-y-2 text-xs font-mono">
              <div>
                <span className="text-neutral-500">General Inquiries: </span>
                <a href={`mailto:${studioData.email}`} className="text-neutral-300 hover:text-arch-accent transition-colors">
                  {studioData.email}
                </a>
              </div>
              <div>
                <span className="text-neutral-500">Instagram: </span>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-neutral-300 hover:text-arch-accent transition-colors">
                  {studioData.instagram}
                </a>
              </div>
              <div>
                <span className="text-neutral-500">LinkedIn: </span>
                <span className="text-neutral-300">{studioData.linkedin}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Technical Architectural Scale & Back To Top */}
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-[10px] font-mono text-neutral-500">
          <div className="flex items-center gap-3">
            <Compass className="w-3.5 h-3.5 text-arch-accent" />
            <span>SCALE BAR: |---|---|---| 1:1000 DRAWING ARCHIVE</span>
          </div>

          <div>
            © {new Date().getFullYear()} {studioData.name}. All rights reserved.
          </div>

          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-arch-accent hover:text-white transition-colors"
          >
            <span>BACK TO TOP</span>
            <ArrowUp className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
};
